import React, { useState, useEffect } from 'react';
import BasicCard from "../../../components/basics/cards/BasicCard"
import { TokenService } from '../../../services/TokenService'
import { NodeAPIService } from '../../../services/apis/NodeAPIService'
import './reporting-structure.css'
import { ErrorService } from '../../../services/ErrorService';

function ReportingStructure() {
    const [selectNodes, setSelectNodes] = useState([])
    const [selectedNodeId, setSelectedNodeId] = useState()
    const [coupledEntities, setCoupledEntities] = useState([])
    const [fetchingEntities, setFetchingEntities] = useState(false)
    const [error, setError] = useState('');

    useEffect(() => {
        NodeAPIService.getNodesByEmail() 
            .then(data => {
                //console.log(data)
                if (!data.error) {
                    setSelectNodes(data);
                    setSelectedNodeId(data[0].nodeId);
                    setError(false)
                }
                else {
                    setError(ErrorService.getErrorMessage(data.error.status));
                }
            })
    }, [])

    useEffect(() => {
        if (selectedNodeId) {
            setFetchingEntities(true)

            // Fetch tagetik entities by selected node ID
            NodeAPIService.getEntitiesByNodeId(selectedNodeId)
                .then(data => {
                    if (data.error) {
                        setError(ErrorService.getErrorMessage(data.error.status));
                    }
                    setCoupledEntities(data)
                    setFetchingEntities(false)
                })
        }
    }, [selectedNodeId])

    return (
        <BasicCard cardConfig={{ cardTitle: 'Reporting structure', cardHeadingElement: 'h4' }}>
            <BasicCard cardConfig={{ cardTitle: 'Entity structure', cardHeadingElement: 'h5' }}>
                {error ?
                    <p style={{ color: 'red' }}>{error}</p> : ""
                }
                <span className='report-structure-select'>
                    <p className='report-structure-label'>Entity and group</p>
                    <select value={selectedNodeId} disabled={fetchingEntities} style={{ opacity: fetchingEntities ? '0.7' : '1' }} onChange={e => setSelectedNodeId(e.target.value)}>
                        {
                            selectNodes && selectNodes.length > 0 ?
                                selectNodes.map(node => (
                                    <option id={node.nodeId} name={node.nodeId} key={node.nodeId} value={node.nodeId }>{node.nodeName}</option>
                                ))
                                : <option>-</option>
                        }
                    </select>
                </span>

                <div className='report-structure-coupled'>
                    <p className='report-structure-label'>Coupled tagetik entities</p>
                    <span className='report-structure-coupled-entities'>
                    {coupledEntities && (
                        coupledEntities.map(entity => {
                            return <p>{`${entity.entityName} - ${entity.entityId}`}</p>
                        })
                    )}
                    </span>
                </div>
            </BasicCard>
        </BasicCard>
    )
}

export default ReportingStructure